import React from 'react';
import { Dialog, Box, Typography, Button } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CommonImages from '../../commons/images';
import GoogleMark from '../components/svgs/googleMark';
import OutlookMark from '../components/svgs/outlookMark';
import useLoginDialog from './useLoginDialog';
import * as styles from './styles';

function LoginDialog({ open, publisher, onClose }) {
    const { googleOauth, outlookOauth, type } = useLoginDialog();

    const publisherLabel = publisher?.publisherName
        ? `Manage ${publisher.publisherName}`
        : 'Manage My ECAL';

    function renderHeader() {
        return (
            <Box sx={styles.header}>
                <Box component="img" src={CommonImages.ECAL_SYMBOL} alt="ECAL" sx={styles.symbol} />
                <Typography sx={styles.title}>{publisherLabel}</Typography>
            </Box>
        );
    }

    function renderSubtitle() {
        return (
            <Typography sx={styles.subtitle}>
                Sign in to manage your calendar connections, find recommendations, and curate your ultimate schedule. You don't need an ECAL account - Google or Outlook is enough.
            </Typography>
        );
    }

    function renderGoogleButton() {
        if (type === 'outlook') return null;
        return (
            <Box
                component="button"
                onClick={googleOauth}
                sx={styles.providerButton(false)}
            >
                <GoogleMark />
                Continue with Google
            </Box>
        );
    }

    function renderOutlookButton() {
        if (type === 'google') return null;
        return (
            <Box
                component="button"
                onClick={outlookOauth}
                sx={styles.providerButton(true)}
            >
                <OutlookMark />
                Continue with Outlook
            </Box>
        );
    }

    function renderLegal() {
        return (
            <Typography sx={styles.legal}>
                By continuing you agree to ECAL's{' '}
                <Box component="a" href="https://ecal.com/terms-of-use/" target="_blank" rel="noreferrer" sx={styles.legalLink}>
                    Terms
                </Box>
                {' '}and{' '}
                <Box component="a" href="https://ecal.com/privacy-policy/" target="_blank" rel="noreferrer" sx={styles.legalLink}>
                    Privacy Policy
                </Box>.
            </Typography>
        );
    }

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth={false}
            aria-label="Sign in to sync"
            sx={styles.dialog}
            slotProps={{
                backdrop: { sx: styles.backdrop },
            }}
        >
            <Button onClick={onClose} aria-label="Close" sx={styles.closeButton}>
                <CloseIcon sx={{ fontSize: 18 }} />
            </Button>

            {renderHeader()}
            {renderSubtitle()}
            {renderGoogleButton()}
            {renderOutlookButton()}
            {renderLegal()}
        </Dialog>
    );
}

export default LoginDialog;
